import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from '@iconify/react'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Collapse from '@mui/material/Collapse'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import type { LoginMethod } from '@jupi/shared'

export const METHOD_ICONS: Record<LoginMethod, string> = {
  password: 'mdi:form-textbox-password',
  magic_link: 'mdi:email-fast-outline',
  passkey: 'mdi:fingerprint',
}

const ORDER: LoginMethod[] = ['passkey', 'magic_link', 'password']

// "What are these?" -- a plain-language account of each way to sign in,
// for members who have never met a passkey or a magic link. Shown on the
// login page and next to the choice on the profile.
export function SignInMethodInfo({ label, defaultOpen = false }: { label?: string; defaultOpen?: boolean }) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(defaultOpen)
  return (
    <Stack spacing={1}>
      <Button
        size="small"
        onClick={() => setOpen((v) => !v)}
        startIcon={<Icon icon="mdi:information-outline" />}
        aria-expanded={open}
        sx={{ alignSelf: 'flex-start' }}
      >
        {label ?? t('auth.whatAreThese')}
      </Button>
      <Collapse in={open}>
        <Alert severity="info" icon={false}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
            {t('auth.info.title')}
          </Typography>
          <Stack spacing={1.5}>
            {ORDER.map((method) => (
              <Stack key={method} direction="row" spacing={1.5} sx={{ alignItems: 'flex-start' }}>
                <Icon icon={METHOD_ICONS[method]} width={22} style={{ flexShrink: 0, marginTop: 2 }} />
                <Typography variant="body2">
                  <strong>{t(`auth.method_${method}`)}.</strong> {t(`auth.info.${method}`)}
                </Typography>
              </Stack>
            ))}
            <Typography variant="body2" color="text.secondary">
              {t('auth.info.anyMethod')}
            </Typography>
          </Stack>
        </Alert>
      </Collapse>
    </Stack>
  )
}
